<template>
    <a :href="`/learn/${category.slug}`" class="md:px-2 cursor-pointer transition ease-in duration-100 transform hover:scale-105">
        <div
            class="text-center h-48 bg-gray-700 rounded-lg flex flex-col justify-end shadow-md flex items-center justify-center px-2 bg-cover"
            :style="{
                backgroundImage: 'linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .6)), url(' + category.coverImage + ')'
            }"
        >
            <h5 class="text-gray-100 text-lg font-medium">{{ category.name }}</h5>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        category: {
            type: Object,
            required: true
        }
    }
};
</script>
